import { safeLocalStorage } from '@ifixit/utils';
import { AnswersData } from './SurveyPopUpData';

interface RecentlySeenEntry {
   count: number;
}

interface RecentlySeenAnswersEntry extends RecentlySeenEntry {
   questionIds: number[];
}

type RecentlySeenMap = {
   [id: string]: RecentlySeenEntry;
};

type DateClicked = {
   clickedSurveyAt: number;
};

type TookSurveyMap = {
   [id: string]: DateClicked;
};

const localStorageKeySeenSurvey = 'seen-survey-prompts';

export function markAnswersSurveySeen(questionId: number): void {
   const recentlySeenMap =
      safeLocalStorage.getJson<RecentlySeenMap>(localStorageKeySeenSurvey) ?? {};
   const surveyEntry = recentlySeenMap[AnswersData.id] as RecentlySeenAnswersEntry | undefined;
   if (surveyEntry) {
      surveyEntry.count++;
      surveyEntry.questionIds.push(questionId);
   } else {
      recentlySeenMap[AnswersData.id] = {
         count: 1,
         questionIds: [questionId],
      } as RecentlySeenAnswersEntry;
   }
   safeLocalStorage.setJson(localStorageKeySeenSurvey, recentlySeenMap);
}

export function getCountOfTimesSeenSurvey(surveyId: string): number {
   const recentlySeenMap =
      safeLocalStorage.getJson<RecentlySeenMap>(localStorageKeySeenSurvey) ?? {};
   return recentlySeenMap[surveyId]?.count ?? 0;
}

export function getQuestionIdsForSeenSurveys(): number[] {
   const recentlySeenMap =
      safeLocalStorage.getJson<RecentlySeenMap>(localStorageKeySeenSurvey) ?? {};
   return (
      (recentlySeenMap[AnswersData.id] as RecentlySeenAnswersEntry | undefined)?.questionIds ?? []
   );
}

const localStorageKeyTakenSurvey = 'taken-surveys';

export function markClickedToTakeSurvey(id: string): void {
   const takenSurveysMap =
      safeLocalStorage.getJson<TookSurveyMap>(localStorageKeyTakenSurvey) ?? {};
   const surveyEntry = takenSurveysMap[id];
   if (surveyEntry) {
      surveyEntry.clickedSurveyAt = Date.now();
   } else {
      takenSurveysMap[id] = {
         clickedSurveyAt: Date.now(),
      };
   }
   safeLocalStorage.setJson(localStorageKeyTakenSurvey, takenSurveysMap);
}

export function alreadyClickedToTakeSurvey(surveyId: string): boolean {
   const takenSurveysMap =
      safeLocalStorage.getJson<TookSurveyMap>(localStorageKeyTakenSurvey) ?? {};
   return takenSurveysMap[surveyId]?.clickedSurveyAt !== undefined;
}
